<template>
  <v-app>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <component v-if="$route.name == 'TestLayout'" :is="layout"></component>
    <router-view v-else @showSnackBar="showSnackBar" />
    <SGSAlert :snackbar="alert" :notificationMessage="msgAlert" @cancel="alert = false" :type="typeAlert" :right="true" :top="true" class="alert" />
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import SGSAlert from "@/components/custom/notification/Alert.vue";
import Principal from "@/components/layouts/Principal.vue";
import ContainerSingle from "@/components/layouts/ContainerSingle.vue";
import { startSessionKeepAlive, stopSessionKeepAlive } from "@/services/sessionKeepAlive";

export default {
  components: { SGSAlert, Principal, ContainerSingle },
  data () {
    return {
      itemsTopMenu: [],
      bandTopMenuMounted: false,
      bandHeaderMounted: false,
      bandBreadCrumbMounted: false,
      alert: false,
      msgAlert: '',
      typeAlert: 'success',
      layout: 'container-single'
    }
  },
  computed: {
    ...mapState({
      overlay: (state) => state.ui.overlay,
    }),
    bandResize() {
      return this.bandHeaderMounted && this.bandTopMenuMounted && this.bandBreadCrumbMounted;
    },
    bandClassCommon() {
      if(this.$route.name == 'WaiverSignForm') return false;
      return true;
    }
  },
  methods: {
    loadTopMenuResponsive (items) {
      this.itemsTopMenu = items;
    },
    resizeMount() {
        this.windowHeight = window.innerHeight;
        let element = document.getElementById("scrolling-techniques-7");
        
        setTimeout(() => {
          if(element) {
            const header = document.getElementById("headerFull");
            const headerHeight = header ? header.clientHeight : 0;
            const topMenu = document.getElementById("topMenuFull");
            const topMenuHeight = topMenu ? topMenu.clientHeight : 0;
            const breadCrumb = document.getElementById("breadcrumbHeader");
            const breadCrumbHeight = breadCrumb ? breadCrumb.clientHeight : 0;
            const newHeight = this.windowHeight - headerHeight - topMenuHeight - breadCrumbHeight;
            element.style.maxHeight = `${newHeight}px`;
            element.style.minHeight = `${newHeight}px`;
          }
        },500);
        
    },
    refreshHeight() {
      this.resizeMount();
      this.$nextTick(() => {
          const parent = this;
          window.addEventListener('resize', () => {
            parent.resizeMount();
          });
      });
    },
    changeBand({index,value}) {
      this[index] = value;
    },
    showSnackBar({snack,msg,type}) {
      this.alert = snack;
      this.msgAlert = msg;
      this.typeAlert = type;
    }
  },
  created() {
    this.$store.dispatch('setUser');
    startSessionKeepAlive();
  },
  beforeDestroy() {
    stopSessionKeepAlive();
  },
  mounted() {},
  updated() {},
  watch: {
    bandResize() {
      this.refreshHeight();
    }
  }
};
</script>

<style lang="scss">
@import "~vue-tabulator/dist/scss/tabulator";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--v-primary-darken2);
}

#nav {padding: 30px;}
/* site-wide styles not included in base config */

.theme--light.v-card,
.theme--light.v-sheet {
  overflow: hidden;
  .v-card__title,
  .v-card__title {
    > i {
      margin: 0px 6px 0 0;
    }
    font-size: 16px;
  }
  .bordered {border: 1px var(--v-primary-base) solid;}
  &.rounded-top {border-top-left-radius: 5px; border-top-right-radius: 5px;}
  &.v-card--outlined {border: 1px var(--v-primary-base) solid !important;
  }
}
.v-tab {
  &.rounded-top {border-top-left-radius: 5px; border-top-right-radius: 5px;}
}

.v-tab--active {
  color: var(--v-lighten-base) !important;
  background-color: var(--v-accent-base);
}
.v-icon {font-size: 16px !important;}
.v-expansion-panel-header--active {min-height: 45px !important;}
.v-card__title.no-color {background-color: #fff !important;}
.v-label.theme--light {font-size: 14px;}
.reportCard {min-height: 54px;}
.v-list-item__content {text-align: left !important;}
.overflow-y-auto-flex {overflow-y: hidden;}
.v-application .headline {color: var(--v-primary-darken2) !important; font-size: 24px !important; }
.theme--dark.v-btn.v-btn--disabled { opacity: 0.9; color: #FFFFFF !important; }
.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg { background-color: var(--v-primary-darken1) !important; }
.heightNavigate {height: 100vh;}
#main-principal .v-card >.container {
  padding-bottom: 80px !important;
}
</style>
